export default "__VITE_ASSET__gi_plcbY__"